import { render, staticRenderFns } from "./copy-form-card.vue?vue&type=template&id=00455ac7&scoped=true&"
import script from "./copy-form-card.vue?vue&type=script&lang=js&"
export * from "./copy-form-card.vue?vue&type=script&lang=js&"
import style0 from "./copy-form-card.vue?vue&type=style&index=0&id=00455ac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00455ac7",
  null
  
)

export default component.exports